<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="onCancel()">
        <span aria-hidden="true">&times;</span>
    </button>
    <h4>{{ "widget_product_create_product_header" | translate }}</h4>
</div>
<div class="modal-body">
    <web-product-name
        [name]="productName"
        [description]="description"
        [shortDescription]="shortDescription"
    ></web-product-name>
    <web-product-images [images]="images" [widgetData]="widgetData" [widgetId]="widgetId"></web-product-images>
    <web-product-detail [controls]="detailControls"></web-product-detail>
    <web-product-price [price]="price" [oldPrice]="oldPrice"></web-product-price>
    @if (!isDigitalProductType) {
        <web-product-variant
            [variants]="variants"
            [properties]="properties"
            [element]="element"
            [(hasPropertiesInEditError)]="hasPropertiesInEditError"
        ></web-product-variant>
    }
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="onCancel()">{{ "cancel" | translate }}</button>
    <button type="button" class="btn btn-success" (click)="onConfirm()">{{ "save" | translate }}</button>
</div>
